import { Option } from 'types/general.types';
import { timeSignatureOptions } from '../SongDetailsForm/constants';

export interface TimeSignatureFormData {
  numberOfBeats: string;
  noteValue: Option | null;
}

export const isCustomValue = (option?: Option) =>
  option?.value === 'custom' ||
  !timeSignatureOptions
    .map((opt) => opt.value)
    .includes(option?.value as string);

export const getDefaultValues = (
  timeSignature?: Option
): TimeSignatureFormData => {
  if (timeSignature && isCustomValue(timeSignature)) {
    const [numberOfBeats, noteValue] = (timeSignature.value as string).split(
      '/'
    );
    return { numberOfBeats, noteValue: { value: noteValue, title: noteValue } };
  }
  return { numberOfBeats: '', noteValue: null };
};
